// extracted by mini-css-extract-plugin
export var closeButton = "_iv-2";
export var closeButtonIcon = "_iv-3";
export var lightboxContent = "_iv-1";
export var lightboxOverlay = "_iv-0";